module.exports = __webpack_public_path__ + "static/media/contentIcon.fb1fb1d2.svg";